
/* eslint-disable max-len */

export default `
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="stroke" d="M27 10L21 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path class="stroke" d="M27 10V4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path class="stroke" d="M27.9747 15.2217C28.123 17.5108 27.6222 19.8724 26.3911 22.0041C23.0781 27.7405 15.7439 29.7029 10.0025 26.389C4.26107 23.0752 2.29391 15.7443 5.61374 9.99589C8.92664 4.25946 16.2609 2.29712 22.0023 5.61096C23.2728 6.34429 24.3059 7.21203 25.1689 8.12529L26 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`
